module.exports = __webpack_public_path__ + "img/joinright.c1283731.png";